import React, {useEffect, useState} from 'react';
import {Nav, Navbar} from 'react-bootstrap';
import {FaShoppingCart} from 'react-icons/fa';
import {useDispatch, useSelector} from 'react-redux';
import LoginModal from "../../modals/LoginModal";
import RegisterModal from "../../modals/RegisterModal";
import './NavbarStyles.css';
import {UserLoggedIn} from "../../hooks/isUserLoggedIn";
import NavbarLoggedInComponent from "./NavbarLoggedInComponent";
import {useCaptureActivity} from "../../hooks/useCaptureActivity";
import {useNavigate} from "react-router-dom";

const NavbarComponent = () => {
    const cartQuantity = useSelector(state => state.cart.totalQuantity);
    const cart = useSelector(state => state.cart)
    const navigate = useNavigate();
    // const cartQuantity = useSelector(state => state.cart ? state.cart.totalQuantity : 0);
    const [showLogin, setShowLogin] = useState(false);
    const [showRegister, setShowRegister] = useState(false);

    const userLoggedIn = UserLoggedIn();
    const dispatch = useDispatch();
    const email = useSelector(state => state.user.user.email)
    const {captureActivity, isLoading, error} = useCaptureActivity();


    useEffect(() => {
        if (cart.cart.length < 1 && cart.totalQuantity > 0) {
            cart.totalQuantity = 0
        }
    }, [cart.cart.length])
    const openRegister = () => {
        setShowLogin(false);
        setShowRegister(true);
    };


    // async function handleOnClick(e) {
    //     e.preventDefault();
    //
    //     const rawHref = e.currentTarget.getAttribute('href'); // e.g. "/learning/tutorials"
    //     // console.log(e.currentTarget.textContent)
    //     try {
    //         if (!e.currentTarget?.textContent)
    //             await captureActivity(email, 'Navbar: Clicked \'Cart\'')
    //         else if (typeof parseInt(e.currentTarget?.textContent) === 'number') {
    //             console.log(typeof parseInt(e.currentTarget?.textContent))
    //             await captureActivity(email, 'Navbar: Clicked \'Cart\'')
    //             console.log('test')
    //         } else
    //             await captureActivity(email, `Navbar: Clicked '${e.currentTarget.textContent.trim()}'`);
    //
    //     } catch (err) {
    //         console.error('Logging failed:', err);
    //     }
    //
    //     // Then push the new route client-side:
    //     navigate(rawHref);
    // }


    async function handleOnClick(e) {
        e.preventDefault();

        const rawHref = e.currentTarget.getAttribute('href'); // e.g. "/learning/tutorials"
        const textContent = e.currentTarget.textContent?.trim() || '';

        try {
            // If there’s no text or it's only digits, assume "Cart"
            if (textContent === '' || /^\d+$/.test(textContent)) {
                await captureActivity(email, "Navbar: Clicked 'Cart'");
            } else {
                await captureActivity(email, `Navbar: Clicked '${textContent}'`);
            }
        } catch (err) {
            console.error('Logging failed:', err);
        }

        // Then push the new route client-side:
        navigate(rawHref);
    }


    return (
        <div>
            {userLoggedIn ? (
                <NavbarLoggedInComponent/>
            ) : (
                <>
                    <Navbar collapseOnSelect expand="lg" className="custom-navbar" variant="dark">
                        <Navbar.Brand href="/" onClick={() => captureActivity(email, 'Clicked on \'THE SEALAB\'')}>THE
                            SEALAB</Navbar.Brand>
                        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto">
                                {/* Left-aligned items (if any) */}
                            </Nav>
                            <Nav className="mx-auto">
                                {/*<Nav.Link href="/showroom" onClick={handleOnClick}>Catalog</Nav.Link>*/}
                                <Nav.Link href="/cabinets/showroom" onClick={handleOnClick}>Catalog</Nav.Link>

                            </Nav>
                            <Nav className="ms-auto">
                                {/*<Nav.Link onClick={() => setShowLogin(true)}>Login</Nav.Link>*/}
                                <Nav.Link onClick={() => {
                                    setShowLogin(true)
                                    captureActivity(email, 'Navbar: Clicked on \'Login\'')
                                }}>Login</Nav.Link>
                                <Nav.Link href="/learning/tutorials" onClick={handleOnClick}>Tutorials</Nav.Link>
                                <Nav.Link href="/customer-support/contact" onClick={handleOnClick}>Contact</Nav.Link>
                                <Nav.Link href="/the-sealab/about-us" onClick={handleOnClick}>About Us</Nav.Link>
                                <Nav.Link href="/the-sealab/gallery" onClick={handleOnClick}>Gallery</Nav.Link>
                                <Nav.Link href="/cart" className="nav-cart-link" onClick={handleOnClick}>
                                    <div className="nav-cart-icon">
                                        <FaShoppingCart size={24} color="white"/>
                                        {cartQuantity > 0 && (
                                            <span className="cart-quantity-badge">{cartQuantity}</span>
                                        )}
                                    </div>
                                </Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                    <LoginModal
                        show={showLogin}
                        handleClose={() => setShowLogin(false)}
                        handleRegisterOpen={openRegister}
                        fromCart={false}
                    />
                    <RegisterModal
                        show={showRegister}
                        handleClose={() => setShowRegister(false)}
                    />
                </>
            )}
        </div>
    );
};

export default NavbarComponent;
